import { Component, Inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BlocoDetalhesInternosComponent } from '../../bloco-detalhes-internos.component';
import { PedidoConsultaInternaOutput } from 'src/app/@shared/models/consulta-detalhes-interno';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-aba-impressao',
  templateUrl: './aba-impressao.component.html',
  styleUrls: ['./aba-impressao.component.scss'],
})
export class AbaImpressaoConsultaInternaComponent {
  static Title = 'Imprimir';
  static Concluido = (el: FormGroup) => {
    return true;
  };
  @Input('pedido') pedido: any;
  @Input() parent: BlocoDetalhesInternosComponent;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: PedidoConsultaInternaOutput
  ) {
    this.pedido = data ?? this.pedido;
  }


  imprimir(divName): void {
    // Obter o elemento que será impresso
    const printElement = document.getElementById(divName);

    if (!printElement) {
      console.error(`Elemento com ID '${divName}' não encontrado.`);
      return;
    }

    // Cria um novo documento temporário para a janela de impressão
    const newWindow = window.open('', '_blank');

    if (!newWindow) {
      console.error('Não foi possível abrir a janela de impressão.');
      return;
    }

    // Copia os estilos de todos os elementos da página para o novo documento
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map(style => style.outerHTML)
      .join('\n');

    // Obter o conteúdo HTML da div desejada
    const htmlContent = printElement.outerHTML;

    // Cria um novo conteúdo com HTML e estilos
    const newContent = `
      <html>
      <head>
        ${styles}
      </head>
      <body>
        ${htmlContent}
      </body>
      </html>
    `;

    // Escreve o conteúdo HTML com os estilos na nova janela de impressão
    newWindow.document.write(newContent);
    newWindow.document.close();

    // Aguarda um curto intervalo para garantir que o conteúdo seja carregado na nova janela
    setTimeout(() => {
      // Chama a função de impressão da nova janela
      newWindow.print();
      // Fecha a janela de impressão após a impressão ser concluída
      newWindow.close();
    }, 500);
  }

}
